import { useTranslation } from 'react-i18next';
import {
  GoogleApiDisclaimer,
  GoogleCalendarAuthButton,
  MicrosoftApiDisclaimer,
  OutlookCalendarAuthButton,
} from '@/components/auth';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useIntegrations } from '@/pages/Schedule/hooks/useIntegrations';
import { IntegrationType } from '@/types/gql.generated';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
  Divider,
  Flex,
  Heading,
  Spinner,
} from '@/ui';
import { DisconnectDialog } from './DisconnectDialog';
import { IntegrationList } from './IntegrationList';

export const IntegrationsSection = () => {
  const { t } = useTranslation('settingsModal', { keyPrefix: 'calendars' });
  const { data, isLoading, isError } = useIntegrations();
  const { value: outlookEnabled } = useFeatureFlag('outlookIntegrationEnabled');

  const integrations = (data ?? []).filter(
    (item) =>
      item.type === IntegrationType.GoogleCalendar ||
      (outlookEnabled && item.type === IntegrationType.OutlookCalendar)
  );

  const showDivider = isLoading || isError || (data && data.length > 0);

  return (
    <Box as="section">
      <Heading as="h3" fontWeight="600" mb="3" size="sm">
        Connected calendars
      </Heading>
      {data ? (
        <IntegrationList integrations={integrations} />
      ) : isLoading ? (
        <Flex align="center" gap="2">
          <Spinner size="sm" /> {t('integrations_loading')}
        </Flex>
      ) : isError ? (
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>{t('integrations_error')}</AlertTitle>
        </Alert>
      ) : null}

      {showDivider && <Divider my="6" />}

      <Flex direction="column" gap="3">
        <GoogleCalendarAuthButton launchOnRedirect="settings:calendars" />
        {outlookEnabled && (
          <OutlookCalendarAuthButton launchOnRedirect="settings:calendars" />
        )}
      </Flex>
      <GoogleApiDisclaimer mt="6" />
      {outlookEnabled && <MicrosoftApiDisclaimer mt="3" />}
      <DisconnectDialog />
    </Box>
  );
};
